import * as React from "react";
import type { SVGProps } from "react";
const SvgEmailNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      d="M16.25 5.005a1 1 0 0 0-.177 0H3.979a.9.9 0 0 0-.229.034l6.241 6.211z"
    />
    <path
      fill="#1D1D1D"
      d="m16.823 5.625-6.256 6.012a.88.88 0 0 1-.606.241.88.88 0 0 1-.606-.24l-6.2-5.967a.8.8 0 0 0-.03.207v8.293c0 .22.09.43.252.586.16.156.38.243.607.243h12.032a.88.88 0 0 0 .607-.243.82.82 0 0 0 .252-.586V5.878a.8.8 0 0 0-.052-.253m-12.25 8.546h-.597v-.593l3.124-2.99.605.585zm11.434 0h-.602l-3.132-2.998.606-.585 3.124 2.99z"
    />
  </svg>
);
export default SvgEmailNegative;
